const playupTheme = {
	colors: {
		primary: '#00f181',
		secondary: '#0FBA66',

		fantasyPrimary: '#ff0056',

		success: '#85C998',
		warning: '#e27301',
		danger: '#C53030',
		info: '#00abd9',
		yellow: '#E8B20D',
		white: '#ffffff',
		black: '#000000',
		blue: '#00549E',

		// our tailwind config
		brandBlack: '#252525',
		light: '#EEE',
		dark: '#3B4A3F',
		grey: '#4C4C4C',
		lightGrey: '#727272',
		darkGrey: '#1A1A1A',

		//tailwind official
		grey900: '#1a202c',

		// portal redesign grey scale colors
		lightGreyR: '#DDE1E3',
		greyR: '#a4a6a8',
		darkGreyR: '#2D3134',
		darkGreyRHighlight: '#4A4D50',
		darkR: '#191D22',

		shadow: 'rgba(0,0,0, 0.36)',
		transparent: 'transparent',
	},
	// key-values from tailwind
	fontSizes: {
		xs: '0.75rem',
		sm: '0.875rem',
		base: '1rem',
		lg: '1.125rem',
		xl: '1.25rem',
		'2xl': '1.5rem',
		'3xl': '1.875rem',
		'4xl': '2.25rem',
		'5xl': '3rem',
		'6xl': '4rem',
	},
	// key-values from tailwind
	spacings: {
		0: '0',
		1: '0.25rem',
		2: '0.5rem',
		3: '0.75rem',
		4: '1rem',
		5: '1.25rem',
		6: '1.5rem',
		8: '2rem',
		10: '2.5rem',
		12: '3rem',
		16: '4rem',
		20: '5rem',
	},
};

export default playupTheme;
